import { Button } from "./_CommonElements";
import { ButtonStyle } from "../../js/enums";

function getButtonOptions(field, optionsEnum) {
  if (field.options && field.options.length > 0) {
    return field.options;
  }

  return Object.entries(optionsEnum).map(([label, value]) => ({
    label,
    value,
  }));
}

function ButtonSelect({
  description,
  errors,
  field,
  label,
  mandatory,
  name,
  optionsEnum,
  setFieldValue,
  showErrorsBeforeTouched,
  touched,
  value,
}) {
  return (
    <div>
      <div className="form-label">
        {label}
        {mandatory && <span className="text-danger"> *</span>}
      </div>
      {description && (
        <p className="mb-3 text-muted">{description}</p>
      )}
      <div className="d-grid gap-3 grid-cols-1 grid-cols-lg-2">
        {getButtonOptions(field, optionsEnum).map((option) => {
          const isSelected =
            String(value || "") === String(option.value);

          return (
            <Button
              key={option.value}
              className="p-3 text-start d-flex"
              icon={option.icon}
              iconClassName="mt-1"
              onClick={() => setFieldValue(name, option.value)}
              style={
                isSelected
                  ? ButtonStyle.Primary
                  : ButtonStyle.OutlineInfo
              }
              text={
                <span className="d-flex flex-column flex-grow-1">
                  <span className="fs-5 lh-sm">{option.label}</span>
                  {option.description && (
                    <span className="d-block mt-2 small">
                      {option.description}
                    </span>
                  )}
                </span>
              }
              type="button"
            />
          );
        })}
      </div>
      {errors && (
        <div className="text-danger mt-2">
          {showErrorsBeforeTouched || touched ? errors : ""}
        </div>
      )}
    </div>
  );
}

export default ButtonSelect;
